import $ from 'jquery';
import Cookies from 'cookies-js';
import constants from 'lib/constants';

function addReferralInfo(params) {
	// add referral information to every link on page that is going to oms
	$('a[data-omslink="true"]').each(function() {
		let href = $(this).attr('href');

		if(href) {
			href += params;
			$(this).attr('href', href);
		}
	});
}

function buildReferralInfo(referral, corp) {
	let params = '';
	let referralInfo;
	let corpInfo;

	// check for referral info and update params
	if(referral) {
		referralInfo = referral.split('|');
		params += '&referral=' + referralInfo[0] + '&source=' + referralInfo[1];
	}

	// check for corp info and update params
	if(corp) {
		corpInfo = corp.split('|');
		params += '&promotionName=' + corpInfo[0] + '&source=web';
	}

	// add params to links
	addReferralInfo(params);
}

function checkReferralInformation() {
	// get member referral cookie
	const memberReferralCookie = Cookies.get(constants.memberReferralCookieName);
	// get corporate membership cookie
	const corpMembershipCookie = Cookies.get(constants.cookieCorpMembership);

	if((memberReferralCookie !== null && typeof memberReferralCookie !== 'undefined' && memberReferralCookie.length > 0) ||
		(corpMembershipCookie !== null && typeof corpMembershipCookie !== 'undefined' && corpMembershipCookie.length > 0)) {
		buildReferralInfo(memberReferralCookie, corpMembershipCookie);
	}
}

$(() => {
	var $mainElement = $('.main-mylt');
	var $viewAllClubsEl = $('.view-all-clubs-prospect');
	if($mainElement.length && $viewAllClubsEl.length){
		$mainElement.addClass('view-all-clubs-main');
		var $stateSelect = $('#state-anchor');
		var offset = 0 - ( $('.locations-toolbar').outerHeight() + $('.state-header').outerHeight() );

		$stateSelect.on('change', () => {
			var anchor = $($stateSelect.val() + ' > .club-result:first-child');
			if(anchor.length > 0) {
				window.lthelp.scrollTo(anchor, offset, 500);
			} else{
				window.lthelp.scrollTo('top', 0, 500);
			}
		});
		checkReferralInformation();
	}
});
